import { db } from '../firebase'
// import { GetPrintersHistory } from './printersHistory.js'
export const GetDealersUsage = function (vm, startAtValue, endAtValue) {
  console.log('GetDealersUsage() Started ...')
  let dealersUsage = {}
  db.ref('Users').orderByChild('UserType').equalTo('Dealer').once('value').then(function (snapUsers) {
    const users = snapUsers.val()
    if (users) {
      for (let i = 0; i < vm.sortedDelaers.length; i++) {
        let dealerKey = vm.sortedDelaers[i].value
        dealersUsage[dealerKey] = {}
        dealersUsage[dealerKey].Logged = ''
        dealersUsage[dealerKey].DealerKey = dealerKey
        dealersUsage[dealerKey].DealerName = vm.isRTL(vm.sortedDelaers[i].title) ? '* NOT Supported *' : vm.sortedDelaers[i].title
        dealersUsage[dealerKey].TotalUSBPrinters = 0
        dealersUsage[dealerKey].TotalNETPrinters = 0
        dealersUsage[dealerKey].TotalPrinter = 0
        dealersUsage[dealerKey].TotalReadPrinters = 0
        dealersUsage[dealerKey].DealerEmail = '* Missing Email *'
        let user = users[dealerKey]
        if (user && user.Email && user.Email.length > 0) {
          dealersUsage[dealerKey].DealerEmail = user.Email
        }
      }
      dealersUsage['MissingDealer'] = {}
      dealersUsage['MissingDealer'] = {}
      dealersUsage['MissingDealer'].Logged = ''
      dealersUsage['MissingDealer'].DealerKey = 'MissingDealer'
      dealersUsage['MissingDealer'].DealerName = '* Missing Dealer *'
      dealersUsage['MissingDealer'].TotalUSBPrinters = 0
      dealersUsage['MissingDealer'].TotalNETPrinters = 0
      dealersUsage['MissingDealer'].TotalPrinter = 0
      dealersUsage['MissingDealer'].TotalReadPrinters = 0
      dealersUsage['MissingDealer'].DealerEmail = '* Missing Email *'
      let childKey = 'LoggedInt'
      startAtValue = vm.fromDateInt + ''
      endAtValue = vm.toDateInt + ''
      console.log(childKey)
      console.log(startAtValue)
      console.log(endAtValue)
      db.ref('Printers').orderByChild(childKey).once('value', (snapPrinters) => {
        const data = snapPrinters.val()
        if (data) {
          const pritnerKeys = Object.keys(data)
          for (let i = 0; i < pritnerKeys.length; i++) {
            let pKey = pritnerKeys[i]
            let printer = data[pKey]
            if (dealersUsage[printer.DealerKey]) {
              if (printer.IsUSB) {
                dealersUsage[printer.DealerKey].TotalUSBPrinters++
              } else {
                dealersUsage[printer.DealerKey].TotalNETPrinters++
              }
              dealersUsage[printer.DealerKey].TotalPrinter++
            } else {
              console.log(printer.DealerKey)
              if (printer.IsUSB) {
                dealersUsage['MissingDealer'].TotalUSBPrinters++
              } else {
                dealersUsage['MissingDealer'].TotalNETPrinters++
              }
              dealersUsage['MissingDealer'].TotalPrinter++
            }
          }
          vm.reportData = []
          vm.reportData = ConverObjectToArray(vm, dealersUsage)
          vm.exportReport(vm, vm.reportData)
        } else {
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Report has no data (No Printers Found)!'
          console.log('Report NO DATA !!')
        }
      })
    } else {
      vm.isLoading = false
      vm.hasData = false
      vm.error = 'Report has no data  (No Dealers Found!)!'
      console.log('Report NO DATA !!')
    }
  })
}

function ConverObjectToArray (vm, dealersUsage) {
  let rptData = []
  const dealersKeys = Object.keys(dealersUsage)
  for (let i = 0; i < dealersKeys.length; i++) {
    let dealerKey = dealersKeys[i]
    let reportDataItem = {
      Logged: dealersUsage[dealerKey].Logged,
      DealerKey: dealerKey,
      DealerName: dealersUsage[dealerKey].DealerName,
      DealerEmail: dealersUsage[dealerKey].DealerEmail,
      UsbPrinters: dealersUsage[dealerKey].TotalUSBPrinters,
      LanPrinters: dealersUsage[dealerKey].TotalNETPrinters,
      TotalPrinter: dealersUsage[dealerKey].TotalUSBPrinters + dealersUsage[dealerKey].TotalNETPrinters,
      TotalReadPrinters: 0
    }
    let fromDateStr = vm.fromDateInt + ''
    let toDateStr = vm.toDateInt + ''
    let historyFilters = {
      fromDate: fromDateStr,
      toDate: toDateStr,
      dealer: dealerKey,
      customers: [],
      datePaths: [vm.filters.year + '/' + vm.filters.month + '/']
    }
    GetDealerCustomers(vm, db, dealerKey).then(function (customersKeys) {
      console.log(customersKeys)
      if (customersKeys) {
        historyFilters.customers = customersKeys
      }
      rptData.push(reportDataItem)
    })
  }
  return rptData
}

function GetDealerCustomers (vm, db, dealerKey) {
  return db.ref('Dealers/' + dealerKey + '/Customers').orderByKey().once('value', (snapCustomers) => {
    const data = snapCustomers.val()
    if (data) {
      let customersKeys = Object.keys(data)
      return customersKeys
    } else {
      return null
    }
  })
}
/*
function test () {
  let historyFilters = {
    fromDate: fromDateStr,
    toDate: toDateStr,
    dealer: vm.filters.dealerKey,
    customers: [],
    datePaths: datesPathList
  }
  GetPrintersHistory(vm, historyFilters).then(function (result) {
    console.log(result)
    if (result.Success) {
      vm.printersHistory = result.Data
    }
    vm.isLoading = false
  }).catch(function (error) {
    console.log(error)
    vm.isLoading = false
  })
}
*/



// WEBPACK FOOTER //
// ./src/plugins/dealersUsage.js